export const USER_COLUMNS = [
  { keys: ["DRAFT"], title: "Drafts" },
  {
    keys: ["SUBMITTED", "USER_RESPONSE"],
    title: "Under review",
    subTitle: undefined,
  },
  { keys: ["ADMIN_FEEDBACK"], title: "Changes required" },
  { keys: ["DONE", "DENIED", "PARTIAL_APPROVED"], title: "Completed" },
];

export const ADMIN_COLUMNS = [
  { keys: ["DRAFT", "SUBMITTED"], title: "Todo", subTitle: "My Drafts" },
  { keys: ["ADMIN_FEEDBACK"], title: "Feedback sent" },
  { keys: ["USER_RESPONSE"], title: "Feedback provided" },
  { keys: ["DONE", "DENIED", "PARTIAL_APPROVED"], title: "Completed" },
];
